import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { Button } from '../ui/Button';

interface DeleteGigModalProps {
  gigTitle: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteGigModal: React.FC<DeleteGigModalProps> = ({
  gigTitle,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div
        className="w-full max-w-[420px] bg-[#111111] border border-white/10 rounded-[24px] overflow-hidden shadow-2xl"
        style={{ animation: 'fadeInScale 0.2s ease-out' }}
      >
        <div className="p-6">
          {/* Close button */}
          <div className="flex items-start justify-between mb-6">
            <div className="w-12 h-12 rounded-xl bg-red-500/10 flex items-center justify-center text-red-500 shrink-0">
              <FiAlertTriangle size={24} />
            </div>
            <button
              onClick={onCancel}
              className="p-2 text-zinc-500 hover:text-white transition-colors -mt-1 -mr-1"
            >
              <FiX size={20} />
            </button>
          </div>

          {/* Content */}
          <h3 className="text-white text-xl font-bold mb-2">Delete Gig</h3>
          <p className="text-zinc-400 text-[15px] leading-relaxed mb-6">
            Are you sure you want to delete{' '}
            <span className="text-white font-semibold">"{gigTitle}"</span>? This action cannot be
            undone.
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="secondary"
              size="lg"
              className="flex-1 rounded-xl bg-zinc-900 border border-white/10 hover:bg-white/5"
              onClick={onCancel}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              size="lg"
              isLoading={isDeleting}
              className="flex-1 rounded-xl bg-red-600 hover:bg-red-500 text-white"
              onClick={onConfirm}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};
